import Loader from 'components/layout/Loader';
import { ConnectedRouter } from 'connected-react-router';
import Layout from 'layouts';
import NotFoundPage from 'pages/system/404';
import React from 'react';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import Switch from 'react-router-transition-switch';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />
  });

const routes = [
  // Dashboards
  {
    path: '/dashboard/analytics',
    Component: loadable(() => import('pages/dashboard/analytics')),
    exact: true
  },
  {
    path: '/enterprise/index',
    Component: loadable(() => import('pages/dashboard/enterprise')),
    exact: true
  },
  {
    path: '/enterprise/create',
    Component: loadable(() => import('pages/dashboard/enterprise/create_new_enterprise')),
    exact: true
  },

  // System Pages
  {
    path: '/system/login',
    Component: loadable(() => import('pages/system/login')),
    exact: true
  },
  {
    path: '/system/forgot-password',
    Component: loadable(() => import('pages/system/forgot-password')),
    exact: true
  },
  {
    path: '/system/register',
    Component: loadable(() => import('pages/system/register')),
    exact: true
  },
  {
    path: '/system/lockscreen',
    Component: loadable(() => import('pages/system/lockscreen')),
    exact: true
  },
  {
    path: '/system/404',
    Component: loadable(() => import('pages/system/404')),
    exact: true
  },
  {
    path: '/system/500',
    Component: loadable(() => import('pages/system/500')),
    exact: true
  },
  {
    path: '/dashboard/users',
    Component: loadable(() => import('pages/dashboard/users')),
    exact: true
  }
];

const mapStateToProps = ({ settings }) => ({ settings });

@connect(mapStateToProps)
class Router extends React.Component {
  render() {
    const {
      history,
      settings: { routerAnimation }
    } = this.props;
    return (
      <ConnectedRouter history={history}>
        <Layout>
          <Switch
            render={props => {
              const {
                children,
                location: { pathname }
              } = props;
              return (
                <SwitchTransition>
                  <CSSTransition
                    key={pathname}
                    classNames={routerAnimation}
                    timeout={routerAnimation === 'none' ? 0 : 300}
                  >
                    {children}
                  </CSSTransition>
                </SwitchTransition>
              );
            }}
          >
            <Route exact path="/" render={() => <Redirect to="/dashboard/analytics" />} />
            {routes.map(({ path, Component, exact }) => (
              <Route path={path} key={path} exact={exact}>
                <Component />
              </Route>
            ))}
            <Route component={NotFoundPage} />
          </Switch>
        </Layout>
      </ConnectedRouter>
    );
  }
}

export default Router;
